import { Model as s } from "../../../../../model.js";
class o extends s {
  constructor(e) {
    super(), this.methodType = e.methodType, this.engine = e.engine, this.channel = e.channel, this.serviceType = e.serviceType, this.status = e.status;
  }
}
export {
  o as ShopSessionPaymentMethodModel
};
//# sourceMappingURL=paymentMethod.model.js.map
